// extracted by mini-css-extract-plugin
export default {"root":"Price-root_nEvfS","price":"Price-price_oFYYT","priceCrossedOut":"Price-priceCrossedOut_kfjPD"};